import { render, staticRenderFns } from "./DenyAccess.vue?vue&type=template&id=5d9ff0d9&scoped=true&"
import script from "./DenyAccess.vue?vue&type=script&lang=js&"
export * from "./DenyAccess.vue?vue&type=script&lang=js&"
import style0 from "./DenyAccess.vue?vue&type=style&index=0&id=5d9ff0d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9ff0d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9ff0d9')) {
      api.createRecord('5d9ff0d9', component.options)
    } else {
      api.reload('5d9ff0d9', component.options)
    }
    module.hot.accept("./DenyAccess.vue?vue&type=template&id=5d9ff0d9&scoped=true&", function () {
      api.rerender('5d9ff0d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/DenyAccess.vue"
export default component.exports